<div class="header">
  <span>
      <a href="/#/inicio"><img src="/assets/images/generico/logo.png" class="logo"></a>
  </span>
</div>

  <div class="container mat_step_container">
    <div class="row" align="right">
      <button class="btn_salir" mat-button (click)="cerrar_vista()">Salir</button>
    </div>
    <div class="row" style="width: 100%; height: 150px; margin-bottom: 3%;">
      <div class="col-12 title-section"> 
        <h1>Solicitudes con Pago al momento del retiro</h1>
        <hr style="width: 70%;">
      </div>
    </div>
    <div id="nose">

      <div class="row">
        <div class="col-md-12" style="text-align: center;">
          <p>
            <b> Elija la opción hacia dónde quiere ir:</b>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8 margin" style="padding-top: 10px; text-align: center;">
          <p><b> Seguimiento de Resoluciones </b></p>
          <li>
            Calificación y valorización. (Documento que permite acogerse a solicitud de POMVS bajo el art 166 LGUC,
            o para ver si mantiene la calidad de vivienda social) El solicitante debe poder indicar para que requiere
            el documento.
          </li>
          <br>
          <div style="text-align: center;">
            <a>
              <button mat-raised-button (click)="sign('resoluciones')" class="button-special-pa">Resoluciones de
                Vivienda Social</button>
            </a>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-12 margin" style="padding-top: 10px; text-align: center;">
          <p><b> Copia de documentos y planos aprobados </b></p>
          <li>
            Copia de los documentos y planos aprobados y archivados por la Dirección de Obras.
          </li>
          <br>
          <div style="text-align: -webkit-center;">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

              <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef> <b> Tipo de documento </b></th>
                <td mat-cell *matCellDef="let element"> {{element.tipo_documento}}</td>
              </ng-container>

              <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef> <b>Valor $ y UTM / Corvi</b> </th>
                <td mat-cell *matCellDef="let element">
                  <div style="white-space: nowrap;">${{ element.valor_clp }} ({{element.valor}} <span *ngIf="element.Valor_entero!='SI'">%</span> {{element.tipo_valor}})</div>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns" style="background-color:lightgray;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>


          </div>

          <br>
          <div style="text-align: center;">
            <a>
              <button mat-raised-button (click)="sign('copia_documentos')" class="button-special-pa">Copia de documentos y
                planos
                aprobados</button>
            </a>
          </div>
        </div>
      </div>

    </div> 
  </div>

  
